

// const CONFIG = {
//     'miplicenses.milestonesys.wdev': {
//         MPM_API_URL: 'https://mpm.milestonesys.wdev/api',
//        /* BACKEND_API_URL: 'https://miplicensesapi.milestonesys.wdev/api',*/
//         IDENTITY_MANAGER_CONFIG: {
//             authority: 'https://sso2.milestonesys.wdev',
//             client_id: 'milestone_mip',
//             redirect_uri:
//                 'https://miplicenses.milestonesys.wdev/authentication-callback',
//             response_type: 'code',
//             scope: 'openid profile email mpm.full offline_access',
//             post_logout_redirect_uri: 'https://www.milestonesys.wdev',
//             accessTokenExpiringNotificationTime: 10
//         },
//     },
//     'miplicenses.milestonesys.wtst': {
//         MPM_API_URL: 'https://mpm.milestonesys.wtst/api',
//        /* BACKEND_API_URL: 'https://miplicensesapi.milestonesys.wtst/api',*/
//         IDENTITY_MANAGER_CONFIG: {
//             authority: 'https://sso2.milestonesys.wtst',
//             client_id: 'milestone_mip',
//             redirect_uri:
//                 'https://miplicenses.milestonesys.wtst/authentication-callback',
//             response_type: 'code',
//             scope: 'openid profile email mpm.full offline_access',
//             post_logout_redirect_uri: 'https://www.milestonesys.wtst',
//             accessTokenExpiringNotificationTime: 10
//         },
//     },
//     'miplicenses.milestonesys.xyz': {
//         MPM_API_URL: 'https://mpm.milestonesys.xyz/api',
//        /* BACKEND_API_URL: 'https://miplicensesapi.milestonesys.xyz/api',*/
//         IDENTITY_MANAGER_CONFIG: {
//             authority: 'https://sso2.milestonesys.xyz',
//             client_id: 'milestone_mip',
//             redirect_uri:
//                 'https://miplicenses.milestonesys.xyz/authentication-callback',
//             response_type: 'code',
//             scope: 'openid profile email mpm.full offline_access',
//             post_logout_redirect_uri: 'https://www.milestonesys.xyz',
//             accessTokenExpiringNotificationTime: 10
//         },
//     },
//     'miplicenses.milestonesys.com': {
//         MPM_API_URL: 'https://mpm.milestonesys.com/api',
//        /* BACKEND_API_URL: 'https://miplicensesapi.milestonesys.com/api',*/
//         IDENTITY_MANAGER_CONFIG: {
//             authority: 'https://sso2.milestonesys.com',
//             client_id: 'milestone_mip',
//             redirect_uri:
//                 'https://miplicenses.milestonesys.com/authentication-callback',
//             response_type: 'code',
//             scope: 'openid profile email mpm.full offline_access',
//             post_logout_redirect_uri: 'https://www.milestonesys.com',
//             accessTokenExpiringNotificationTime: 10
//         },
//     },
//     localhost: {
//         MPM_API_URL: 'https://mpm.milestonesys.wdev/api',
//         /*BACKEND_API_URL: 'https://miplicensesapi.milestonesys.wdev/api',*/
//         IDENTITY_MANAGER_CONFIG: {
//             authority: 'https://sso2.milestonesys.wdev',
//             client_id: 'milestone_mip',
//             redirect_uri: 'http://localhost:3000/authentication-callback',
//             response_type: 'code',
//             scope: 'openid profile email roles mpm.full offline_access',
//             post_logout_redirect_uri: 'https://www.milestonesys.wdev',
//             accessTokenExpiringNotificationTime: 10
//         },
//     },
// };

// export const loadConfig = (): void => {
//     environment = window.location.host.split(':')[0];
// };

// export const MPM_API_URL = (): string => CONFIG[environment].MPM_API_URL;
// export const BACKEND_API_URL = (): string =>
//     CONFIG[environment].BACKEND_API_URL;
// export const IDENTITY_MANAGER_CONFIG = (): Oidc.UserManagerSettings =>
//     CONFIG[environment].IDENTITY_MANAGER_CONFIG;
// export const LICENSE_MANAGMENT_USER_ROLE = 'License Admin';
// export const INTEGRATION_MANAGMENT_USER_ROLE = 'Application Track User';


// src/config.ts
let environment = window.location.host.split(':')[0];

const CONFIG = {
    'miplicenses.milestonesys.wdev': {
        MILESTONE_URL: 'https://www.milestonesys.wtst', // optional, can stay dev
        API_URL: 'https://mpm.milestonesys.wtst/api', // optional, can stay dev
        CLIENT_URL: 'http://miplicenses.milestonesys.wdev',
        IDENTITY_MANAGER_CONFIG: {
            authority: 'https://26e06b8c-36a0-4842-9e74-63170413cbd9.ciamlogin.com/26e06b8c-36a0-4842-9e74-63170413cbd9/',
            knownAuthorities: ['id.milestonelogin.top'],
            client_id: 'fde40fec-97a6-417c-a0c2-aee9546af954',
            redirect_uri: 'http://miplicenses.milestonesys.wdev/authentication-callback',
            response_type: 'code',
            scope: 'openid profile api://2a9eb6f2-a3d2-4129-a1e7-0d948fc2471d/access_as_user',
            post_logout_redirect_uri: 'http://miplicenses.milestonesys.wdev/',
            accessTokenExpiringNotificationTime: 10,
            monitorSession: false,
        },
    },

    'miplicenses.milestonesys.wtst': {
        MILESTONE_URL: 'https://www.milestonesys.wtst',
        API_URL: 'https://mpm.milestonesys.wtst/api',
        CLIENT_URL: 'https://miplicenses.milestonesys.wtst',
        IDENTITY_MANAGER_CONFIG: {
            authority: 'https://26e06b8c-36a0-4842-9e74-63170413cbd9.ciamlogin.com/26e06b8c-36a0-4842-9e74-63170413cbd9/',
            knownAuthorities: ['id.milestonelogin.top'],
            client_id: 'fde40fec-97a6-417c-a0c2-aee9546af954',
            redirect_uri: 'https://miplicenses.milestonesys.wtst/authentication-callback',
            response_type: 'code',
            scope: 'openid profile api://2a9eb6f2-a3d2-4129-a1e7-0d948fc2471d/access_as_user',
            post_logout_redirect_uri: 'https://miplicenses.milestonesys.wtst',
            accessTokenExpiringNotificationTime: 10,
            monitorSession: false,
        },
    },

    'miplicenses.milestonesys.xyz': {
        MILESTONE_URL: 'https://www.milestonesys.xyz', 
        API_URL: 'https://mpm.milestonesys.xyz/api', 
        CLIENT_URL: 'https://miplicenses.milestonesys.xyz/',
        IDENTITY_MANAGER_CONFIG: {
            authority: 'https://6978af3d-26be-4e79-903b-403635a4db5c.ciamlogin.com/6978af3d-26be-4e79-903b-403635a4db5c',
            knownAuthorities: ['id.milestonelogin.top'],
            client_id: '22b12659-a58d-4d7f-a9f3-6e97fd0cab23',
            redirect_uri: 'https://miplicenses.milestonesys.xyz/authentication-callback',
            response_type: 'code',
            scope: 'openid profile api://b70c1267-e69f-4bfa-b820-f3649a893867/access_as_user',
            post_logout_redirect_uri: 'https://miplicenses.milestonesys.xyz/',
            accessTokenExpiringNotificationTime: 10,
            monitorSession: false,
        },
    },

    'miplicenses.milestonesys.com': {
        MILESTONE_URL: 'https://www.milestonesys.com',
        API_URL: 'https://mpm.milestonesys.com/api',
        CLIENT_URL: 'https://miplicenses.milestonesys.com',
        IDENTITY_MANAGER_CONFIG: {
            authority: 'https://4321ea88-b4d3-4729-a8db-e18baa8c6f30.ciamlogin.com/4321ea88-b4d3-4729-a8db-e18baa8c6f30',
            client_id: '1470f838-0b65-4e61-a830-c3d35dc66859',
            redirect_uri: 'https://miplicenses.milestonesys.com/authentication-callback',
            response_type: 'code',
            scope: 'openid profile api://43af2d84-9ec4-4919-a924-e501fe60f550/access_as_user',
            post_logout_redirect_uri: 'https://miplicenses.milestonesys.com',
            accessTokenExpiringNotificationTime: 10,
            monitorSession: false,
        },
    },
    //'localhost': {
    //    MILESTONE_URL: 'https://www.milestonesys.wtst', // optional, can stay dev
    //    API_URL: 'https://mpm.milestonesys.wtst/api', // optional, can stay dev
    //    CLIENT_URL: 'http://localhost:3000',
    //    IDENTITY_MANAGER_CONFIG: {
    //        authority:'https://26e06b8c-36a0-4842-9e74-63170413cbd9.ciamlogin.com/26e06b8c-36a0-4842-9e74-63170413cbd9/',
    //        knownAuthorities: ['id.milestonelogin.top'],
    //        client_id: 'fde40fec-97a6-417c-a0c2-aee9546af954',
    //        redirect_uri: 'http://localhost:3000/authentication-callback',
    //        response_type: 'code',
    //        scope: 'openid profile api://2a9eb6f2-a3d2-4129-a1e7-0d948fc2471d/access_as_user',
    //        post_logout_redirect_uri: 'http://localhost:3000/',
    //        accessTokenExpiringNotificationTime: 10,
    //        monitorSession: false,
    //    },
    //},
}

export const loadConfig = () => {
    environment = window.location.host.split(':')[0]
}
loadConfig();
export const API_URL = () => CONFIG[environment].API_URL
export const CLIENT_URL = () => CONFIG[environment].CLIENT_URL
export const MILESTONE_URL = () => CONFIG[environment].MILESTONE_URL
export const ENV = () => environment
export const IDENTITY_MANAGER_CONFIG = () => CONFIG[environment].IDENTITY_MANAGER_CONFIG

// Role constants (used for selectors)
export const LICENSE_MANAGMENT_USER_ROLE = "License Admin"
export const INTEGRATION_MANAGMENT_USER_ROLE = "Application Track User"

// Backwards compatibility aliases
export const BACKEND_API_URL = API_URL
export const MPM_API_URL = API_URL
